import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import GridUnit from './GridUnit';
import { GridContext } from './GridContext';
import { AlignItems, JustifyContent } from '../../theme';
import * as styles from './Grid.style';
export * from './types';
export const Grid = _ref => {
  let {
    wrap,
    gutter,
    valign,
    halign,
    addCSS,
    children,
    ...rest
  } = _ref;
  const gridContext = useMemo(() => ({
    gutter,
    wrap
  }), [gutter, wrap]);
  return /*#__PURE__*/React.createElement(GridContext.Provider, {
    value: gridContext
  }, /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    $gutter: gutter,
    $wrap: wrap,
    $valign: valign,
    $halign: halign,
    $addCSS: addCSS
  }, rest, {
    $_css: styles.grid
  }), children));
};
Grid.Context = GridContext;
Grid.Unit = GridUnit;
Grid.defaultProps = {
  wrap: true,
  gutter: 0,
  valign: AlignItems.INITIAL,
  halign: JustifyContent.INITIAL
};
export default Grid;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Grid___StyledDiv",
  componentId: "sc-b6p2xz-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Grid.js.map